import { create } from 'zustand';

interface BoardAgentsManageState {
  isOpen: boolean;
}

interface BoardAgentsManageActions {
  open: () => void;
  close: () => void;
}

type BoardAgentsManageStore = BoardAgentsManageState & BoardAgentsManageActions;

export const useBoardAgentsManageStore = create<BoardAgentsManageStore>(
  (set) => ({
    isOpen: false,
    open: () => set({ isOpen: true }),
    close: () => set({ isOpen: false }),
  }),
);
